"use client";

import { useMemo } from "react";

import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

function digitsOnly(value: string): string {
  return value.replace(/\D/g, "").slice(0, 9);
}

export function formatSsnDisplay(digits: string): string {
  const clean = digitsOnly(digits);
  if (clean.length <= 3) return clean;
  if (clean.length <= 5) return `${clean.slice(0, 3)}-${clean.slice(3)}`;
  return `${clean.slice(0, 3)}-${clean.slice(3, 5)}-${clean.slice(5)}`;
}

export function SsnInput({
  id,
  value,
  disabled,
  placeholder = "000-00-0000",
  className,
  onChange,
}: {
  id?: string;
  value: string;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  onChange: (digits: string) => void;
}) {
  const display = useMemo(() => formatSsnDisplay(value), [value]);

  return (
    <Input
      id={id}
      type="text"
      inputMode="numeric"
      autoComplete="off"
      spellCheck={false}
      disabled={disabled}
      placeholder={placeholder}
      className={cn("font-mono tracking-wide", className)}
      value={display}
      onChange={(event) => onChange(digitsOnly(event.target.value))}
      aria-label="Social Security number"
    />
  );
}
